import { render, staticRenderFns } from "./custom-form-item.vue?vue&type=template&id=997c8b04&scoped=true&"
import script from "./custom-form-item.vue?vue&type=script&lang=js&"
export * from "./custom-form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997c8b04",
  null
  
)

export default component.exports